import { Reducer } from "redux";
import { IAuthenticationContainerState } from "./authentication";
import { IAuthenticationAction, AuthenticationAction } from "./authentication.actions";

const initialState: IAuthenticationContainerState = {};

export const authenticationReducer: Reducer<IAuthenticationContainerState, IAuthenticationAction> = (state = initialState, action) => {
    switch (action.type) {
        case AuthenticationAction.LOGIN: {
            return {
                ...state,
                authenticationIsLoading: true,
            };
        }
        case AuthenticationAction.LOGIN_ERROR: {
            return {
                ...state,
                authenticationIsLoading: false,
                showAuthenticationError: true,
            };
        }
        case AuthenticationAction.LOGIN_SUCCESS: {
            return {
                ...state,
                authenticationIsLoading: false,
                showAuthenticationError: false,
            };
        }
        case AuthenticationAction.SET_USER: {
            return {
                ...state,
                user: action.user,
                showAuthenticationError: false,
            };
        }
        case AuthenticationAction.LOGOUT: {
            return {
                ...state,
                user: undefined,
                authenticationIsLoading: false,
                showAuthenticationError: false,
            };
        }
        default: {
            return state;
        }
    }
};
